import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { initialState } from './initialState';

export const thinfinitySlice = createSlice({
  name: 'thinfinity',
  initialState,
  reducers: {
    setThinfinityVisivility: (state, { payload }: PayloadAction<any>) => {
      state.hidden = payload;
    },
    setThinfinityTittle: (state, { payload }: PayloadAction<any>) => {
      state.tittle = payload;
    },
    setData: (state, { payload }: PayloadAction<any>) => {
      state.data = payload;
    },
  },
  extraReducers: (builder) => {},
});

export const {setThinfinityVisivility, setThinfinityTittle, setData} = thinfinitySlice.actions;

export default thinfinitySlice.reducer;
